import { LocalNotifications } from '@capacitor/local-notifications';

// ID stable pour la notification de streak — doit être unique dans l'app
const REMINDER_ID = 1001;

// ── Local Notifications (rappel streak) ──────────────────────────────────────

export async function scheduleStreakReminder(streakDays = 0) {
  try {
    const perm = await LocalNotifications.requestPermissions();
    // Certaines versions / plateformes ne retournent pas de champ "display"
    if (perm?.display === 'denied') return;

    // Annuler l'éventuelle notification précédente avant de replanifier
    await cancelStreakReminder();

    // Rappel unique : demain à 19h00 (heure locale de l'appareil)
    const reminderAt = new Date();
    reminderAt.setDate(reminderAt.getDate() + 1);
    reminderAt.setHours(19, 0, 0, 0);

    const body = streakDays >= 7
      ? `🔥 ${streakDays} jours de streak ! Continue comme ça !`
      : "📖 Reviens aujourd'hui pour continuer ton streak !";

    await LocalNotifications.schedule({
      notifications: [{
        id:    REMINDER_ID,
        title: 'Manna',
        body,
        // Notification unique, pas de répétition ni d'alarme exacte
        schedule: { at: reminderAt },
        extra: { type: 'streak_reminder' },
      }],
    });
  } catch (err) {
    console.warn('[Notifications] scheduleStreakReminder échoué:', err?.message ?? err);
  }
}

export async function cancelStreakReminder() {
  try {
    await LocalNotifications.cancel({ notifications: [{ id: REMINDER_ID }] });
  } catch {
    // Silencieux — la notification n'existait peut-être pas encore
  }
}
